import { map } from "rxjs";
import { DBFactory } from "~/classes/database/db_factory";
import {
  EvaluationTestRun,
  EvaluationTestRunResults,
} from "./evaluation_test_run.model";

export class EvaluationsService {
  static streamEvaluationTestRuns({
    metricId,
    status,
  }: {
    metricId?: string;
    status?: EvaluationTestRunStatus;
  }) {
    let query = [] as ModelQueryConfig;

    if (metricId) {
      query.push({
        type: "where",
        field: "evaluationMetricId",
        operator: "==",
        value: metricId,
      });
    }

    if (status) {
      query.push({
        type: "where",
        field: "status",
        operator: "==",
        value: status,
      });
    }

    query.push({
      type: "orderBy",
      field: "label",
      direction: "asc",
    });

    const db = DBFactory.createDatabase();
    return db
      .streamList(
        {
          path: "/evaluationTestRuns",
          collection: "/evaluationTestRuns",
        },
        query
      )
      .pipe(
        map((data) => {
          return data.map((doc) => {
            return EvaluationTestRun.fromMap(doc);
          });
        })
      );
  }

  static async fetchEvaluationTestRun({ id }: { id: string }) {
    const db = DBFactory.createDatabase();
    const data = await db.get({
      path: `/evaluationTestRuns/${id}`,
      collection: "/evaluationTestRuns",
    });

    return EvaluationTestRun.fromMap(data);
  }

  static streamEvaluationTestRunTests({
    evaluationTestRunId,
  }: {
    evaluationTestRunId: string;
  }) {
    const db = DBFactory.createDatabase();
    return db
      .streamList(
        {
          path: `/evaluationTestRuns/${evaluationTestRunId}/evaluationTests`,
          collection: `/evaluationTestRuns/${evaluationTestRunId}/evaluationTests`,
        },
        [
          {
            type: "orderBy",
            field: "createdAtTimestamp",
            direction: "desc",
          },
        ]
      )
      .pipe(
        map((data) => {
          return data.map((doc) => {
            return {
              ...doc,
              id: doc.id,
            } as EvaluationTest;
          });
        })
      );
  }

  static async fetchEvaluationTests({
    evaluationMetricId,
    evaluationStatus,
  }: {
    evaluationMetricId: string;
    evaluationStatus: EvaluationTestStatus;
  }) {
    const db = DBFactory.createDatabase();
    const data = await db.list(
      {
        path: `/evaluationTests`,
        collection: "/evaluationTests",
      },
      [
        {
          type: "where",
          field: "metricId",
          operator: "==",
          value: evaluationMetricId,
        },
        {
          type: "where",
          field: "status",
          operator: "==",
          value: evaluationStatus,
        },
        {
          type: "orderBy",
          field: "createdAtTimestamp",
          direction: "desc",
        },
      ]
    );

    return data.map((doc) => {
      return {
        ...doc,
        id: doc.id,
      } as EvaluationTest;
    });
  }

  static streamEvaluationTestRunResults({
    evaluationTestRunId,
  }: {
    evaluationTestRunId: string;
  }) {
    const db = DBFactory.createDatabase();
    return db
      .streamList(
        {
          path: `/evaluationTestRuns/${evaluationTestRunId}/results`,
          collection: `/evaluationTestRuns/${evaluationTestRunId}/results`,
        },
        [
          {
            type: "orderBy",
            field: "createdAt",
            direction: "desc",
          },
        ]
      )
      .pipe(
        map((data) => {
          return data.map((doc) => {
            return EvaluationTestRunResults.fromMap(doc);
          });
        })
      );
  }
}
